import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';

@Directive({
  selector: '[evencharacter-validator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EvencharacterValidatorDirective,
      multi: true
    }
  ]
})
export class EvencharacterValidatorDirective {
  validator: ValidatorFn;

  constructor() {
    this.validator = this.eventCharacterValidator();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  eventCharacterValidator(): ValidatorFn {
    return (c: FormControl) => {
      let isValid = true;
      if (c && c.value) {
        isValid = (<string>c.value).length % 2 == 0;
      }
      if (isValid) {
        return null;
      } else {
        return {
          datevalidator: {
            valid: false
          }
        };
      }
    }
  }

}
